export default __webpack_public_path__ + "static/media/icon-radiopublic.c40b34ab.svg";